<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     未认证功能限制confirm
  +---------------------------------------------------------------------------------------
-->

<template>
  <div>
    <!-- 可以不需要实际的 DOM 元素 -->
  </div>
</template>

<script>
export default {
  methods: {
    async showConfirm(options) {
      const { onConfirm, onCancel, router } = options
      return this.$confirm('请先完成账号实名认证！', '提示', {
        confirmButtonText: '前往认证',
        cancelButtonText: '取消',
        type: 'error'
        }).then(() => {
          if (typeof onConfirm === 'function') {
            onConfirm(router);
          }
        }).catch(() => {
          if (typeof onCancel === 'function') {
            onCancel();
          }
        })
    }
  }
};
</script>

<style scoped>
</style>     